__turbopack_context__.v({
  "card": "Pricing-module-scss-module__p7Acvq__card",
  "price": "Pricing-module-scss-module__p7Acvq__price",
});
